import { RadioChipsGroup } from '@cian/ui-kit';
import { EOffersStatus, ERoomType } from 'shared/types/offers';
import { useSelector } from 'react-redux';
import {
  selectDealTypeFilter,
  selectOffersCount,
  selectOffersStatus,
  selectRoomTypeFilter,
  selectRoomTypeOptions,
} from 'shared/selectors/offers';
import { ChangeEvent, useCallback } from 'react';
import { useAppDispatch } from 'shared/hooks';
import { setRoomTypes } from 'shared/slices/offers';
import { RoomTypeFilter } from 'shared/components/RoomTypeFilter';
import { useDeviceType } from '../../context';
import { useAwaitingTracking, useGetOffersByDeviceType } from '../../hooks';
import { trackRoomTypeFilterChange } from '../../tracking';

export const RoomsTypeFilterContainer = () => {
  const dispatch = useAppDispatch();
  const deviceType = useDeviceType();
  const getOffers = useGetOffersByDeviceType();

  const dealType = useSelector(selectDealTypeFilter);
  const roomType = useSelector(selectRoomTypeFilter);
  const roomTypeOptions = useSelector(selectRoomTypeOptions);
  const offersCount = useSelector(selectOffersCount);
  const status = useSelector(selectOffersStatus);

  const memoizedTracking = useCallback(() => {
    trackRoomTypeFilterChange({ roomType, count: offersCount });
  }, [offersCount, roomType]);

  const awaitTracking = useAwaitingTracking(memoizedTracking);

  const handleChange = (_: ChangeEvent<HTMLInputElement>, value: ERoomType | 'all') => {
    dispatch(setRoomTypes(value === 'all' ? /* istanbul ignore next */ null : [value]));
    getOffers();
    awaitTracking();
  };

  return (
    <RoomTypeFilter
      options={
        <RadioChipsGroup
          options={roomTypeOptions}
          value={roomType}
          onChange={handleChange}
          scrollable={deviceType !== 'desktop'}
          // актуально для мобвеба, чтобы при смене типа сделки фильтры подскролливались к началу
          key={`room-type-filter-${dealType}`}
        />
      }
      showSkeletonFilters={status === EOffersStatus.Pending}
    />
  );
};
